export default "__VITE_ASSET__DJPqGS_X__"